import WorksServices from '../xx-vue/services/works'
export default {
    namespaced: true,
    state: {
        page: 1,
        limit: 12,
        total: 0,
        worksClass: {},
        worksList: [],
        worksList_bottom: []
    },
    mutations: {
        getWorksList: (state, payload) => {
            state.worksList = payload
            console.log(state.worksList);
        },
        changePage: (state, payload) => {
            state.page = payload
        },
        changeLimit: (state, payload) => {
            state.limit = payload
        },
        changeClass: (state, payload) => {
            state.worksClass = payload
        },
        changeTotal: (state, payload) => {
            state.total = payload
        },
        changeBottomList: (state, payload) => {
            state.worksList_bottom = payload
        }
    },
    actions: {
        getWorksList: async ({ commit, state }, payload) => {
            let result = await WorksServices.getWorksAsync({ page: state.page, limit: state.limit, project_id: payload.project_id, group_id: state.worksClass.id, ticket: 'ticket' });
            commit('changeTotal', result.data.total)
            commit('getWorksList', result.data.list)
            const bottomList = result.data.list.slice(3)
            commit('changeBottomList', bottomList)
        },
        send_Ticket: async ({ dispatch }, payload) => {
            const result = await WorksServices.sendTicketAsyncasync({ opus_id: payload.item.id });
            if (result.code === 200) {
                dispatch('getWorksList', payload.project_id)
                return true;
            } else {
                return false
            }
        }
    },
    getters: {
        pages: state => {
            return Math.ceil(state.total / state.limit);
        }
    }
}